import { queryKeys } from "@cashsync/shared";

/**
 * After a genuine revoke-session success the device list must refetch by itself.
 * Takes the client as a parameter so the query key is asserted without the app singleton.
 */
export function refreshSessionsAfterRevoke(client: {
  invalidateQueries: (filter: { queryKey: readonly unknown[] }) => Promise<unknown>;
}): Promise<unknown> {
  return client.invalidateQueries({ queryKey: queryKeys.auth.activeSessions() });
}
